export const FEATURED_SHOVELER = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.FeaturedShovelerWidgetElement';
